import React, { useEffect, useState } from 'react'
import { BsFillPersonFill } from 'react-icons/bs'
import { AiOutlineForm, AiOutlineLogout } from 'react-icons/ai'
import { useNavigate } from 'react-router-dom'
import './sidebar.css'
import logo1 from '../../StudentRegristrationDesign/jain logo.png'

function Sidebar() {
  const [isOpen, setIsOpen] = useState(true)



  const navigate = useNavigate()

  useEffect(() => {
    let sessionData = sessionStorage.getItem('member_id')
    if (!sessionData) {
      navigate('/')
    }
  }, [])



  return (
    <div
      className={`sidebar ${isOpen ? 'open' : ''}`}
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1',        
        height: '100vh',
        background: '#a2d6f8ff',
        color: '#fff',
        fontFamily: 'Poppins, sans-serif',
        transition: 'all 0.3s ease',
      }}
    >
      <div className="row logo-details text-center  mb-5">
        <div
          className="logo_name"
          style={{
            color: 'maroon',
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            fontSize: '24px',
            fontWeight: 'bold',
            letterSpacing: '1px',
            fontFamily: 'Arial, sans-serif',
          }}
        >
           <img
                      src={logo1}
                      alt="Logo"
                      style={{ mixBlendMode: 'darken',height:"100px" }}
                    />
        </div>   
      </div>

      <div className="sidebar-content">
        <ul className="nav-list" style={{ padding: '0 10px', }}>
          {/* <li>
            <a href="/#/BlockRoomBooking" style={{ paddingRight: '90px' }}>
              <i className="fa-solid fa-house-user"></i>
              <span className="links_name">Room Booking</span>
            </a>
          </li> */}
           <li>
              <a
                href="/#/BlockRoomBooking"
                className="active"
                style={{ backgroundColor: 'transparent' }}
              >
               <i className="fa-solid fa-house-user"></i>
                {isOpen &&<span className="links_name">Room Booking</span>}
              </a>
              <span className="tooltip">Room Booking</span>
            </li>
        </ul>
      </div>
    </div>
  )
}

export default Sidebar
